'use strict';

export default typeof FormData !== 'undefined' ? FormData : null;



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/platform/browser/classes/FormData.js
// module id = 336
// module chunks = 14